<template>
  <div class="nav-3">
    <div class="bumen fl">
      <!--<li class="img-3"><img src="/templets/canlian/images/xgbm.png"/></li>-->
      <li v-for="(item,index) in newsClassList" :key="index">
        <a @click="jump(item)">{{item.classCName}}</a>|
      </li>
    </div>
    <div class="sousou fr">
      <table border="0" cellspacing="0" cellpadding="0" width="100%">
        <form id="Search_Form" name="Search_Form" method="get" action="#"></form>
        <tbody>
          <tr>
            <td>
              <input
                id="tags"
                type="text"
                class="fl"
                title="搜索文本框"
                accesskey="s"
                size="10"
                maxlength="20"
                onkeydown="javascript:if(event.keyCode==13){return false;}"
              />
              <input
                name="buttongo"
                class="ss fr"
                title="搜索"
                type="button"
                value
                @click="SearchGo61627"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import Bus from "../assets/bus";
import { mapState } from "vuex";
import news from "../http/web/news";
export default {
  data() {
    return {
      list: [
        "组织建设",
        "教育就业",
        "康复",
        "宣传文体",
        "机关党委",
        "维权",
        "直属单位",
        "石家庄益民残疾人福利基金会"
      ],
      newsClassList: []
    };
  },
  computed: {
    ...mapState({
      baseUrl: state => state.global.baseUrl
    })
  },
  beforeCreate: function() {
    Bus.$on("val", res => {
      console.log('ck石家庄益民残疾人福利基金会',Array.from(res));
      Array.from(res).forEach(item => {
        if (this.list.indexOf(item.classCName) > -1 && item.child != null) {
          console.log('ck走了',item);
          this.newsClassList.push(item);
        }
      });
    });
  },
  methods: {
    SearchGo61627: function() {
      //   alert("11111");
      if (
        document.getElementById("tags").value.length < 2 ||
        document.getElementById("tags").value.length > 10
      ) {
        alert("搜索最小长度2字符，最大长度10字符。");
        return false;
      }
      if (document.getElementById("tags").value == "") {
        alert("请填写关键字");
        return false;
      }
      window.location.href =
        this.baseUrl +
        "/search?keyword=" +
        document.getElementById("tags").value;
    },
    jump(item) {
      news.countByClassId(item.classId).then(res => {
        if (res <= 0 && item.classTemplet != "/childClass") {
          window.location.href =
            item.isUrl == 1
              ? item.urlAddress
              : this.baseUrl +
                (item.child[0].classTemplet +
                  "?classId=" +
                  item.child[0].classId);
        } else {
          window.location.href =
            item.isUrl == 1
              ? item.urlAddress
              : this.baseUrl + (item.classTemplet + "?classId=" + item.classId);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Nav3.vue